import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Home from "./features/home/Home";
import Login from "./features/user/Login"
import SignUp from "./features/user/Signup"
import Navbar from "./app/components/Navbar";
import RequireAuth from "./app/RequireAuth";
import ToDoList from "./features/todo/ToDoList";
import Settings from "./features/settings/Settings";
import NotFoundSvg from "./assets/404.svg";
import ErrorBoundary from "./app/ErrorBoundary";
// import { useAppSelector, useAppDispatch } from "./app/hooks";
// import { logout } from "./features/user/userSlice";

function NotFound() {
  return (
    <div className="not-found">
      <div>
        <h1>404 Error, Page not found</h1>
        <Link to="/">Go to Home</Link>
      </div>
      <div>
        <img src={NotFoundSvg} alt="404" />
      </div>
    </div>
  );
}

function App() {
  // const dispatch = useAppDispatch();
  // const todos = useAppSelector((state) => state.todo);

  
  useEffect(() => {
    let token = localStorage.getItem("token");
    if (!token || token === null || token === undefined) {
      localStorage.removeItem("token");
    }
  }, []);

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <div className="app">
          <Navbar />
          <ErrorBoundary>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route
                path="/settings"
                element={
                  <RequireAuth>
                    <Settings />
                  </RequireAuth>
                }
              >
                <Route path=":option" element={<Settings />} />
              </Route>
              <Route
                path="/todos"
                element={
                  <RequireAuth>
                    <ToDoList />
                  </RequireAuth>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </ErrorBoundary>
        </div>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
